import { APPOINTMENT } from '@components/appointments/constants';

type ApptLocationInfo = {
  translate: (key: string, args: { roomName: string; tableName: string }) => string;
  apptStatus: string;
  parentLocationDisplayName: string;
  locationDisplayName: string;
  vCal: boolean;
};

type ApptLocationInfoBooth = {
  translate: (key: string, args: { roomName: string; tableName: string }) => string;
  apptStatus: string;
  parentLocationDisplayName: string;
  locationDisplayName: string;
  boothLocationName: string;
  vCal: boolean;
};

export const getLocationName = ({
  translate,
  apptStatus,
  parentLocationDisplayName,
  locationDisplayName,
  vCal
}: ApptLocationInfo): string => {
  if (!apptStatus) {
    return '';
  }

  if (
    apptStatus.toUpperCase() === APPOINTMENT.STATUS.PENDING_APPROVAL_AND_ASSIGNMENT ||
    apptStatus.toUpperCase() === APPOINTMENT.STATUS.PENDING_ASSIGNMENT
  ) {
    return parentLocationDisplayName;
  }

  const loc = parentLocationDisplayName
    ? translate('Universal-FullLocationName', {
        roomName: parentLocationDisplayName,
        tableName: locationDisplayName || ''
      })
    : locationDisplayName;

  if (vCal) {
    return loc?.replace(',', '\\,');
  }
  return loc;
};

export const getLocationNameBooth = ({
  translate,
  apptStatus,
  parentLocationDisplayName,
  locationDisplayName,
  boothLocationName,
  vCal
}: ApptLocationInfoBooth): string => {
  let loc = getLocationName({
    translate,
    apptStatus,
    parentLocationDisplayName,
    locationDisplayName,
    vCal
  });

  if (boothLocationName == null || boothLocationName === '') {
    return loc;
  }

  // escape character format is different for ics calendar files
  const comma = vCal ? '\\, ' : ', ';

  loc = loc == null || loc === '' ? boothLocationName : loc + comma + boothLocationName;

  return loc;
};
